var exports = {
  "kL": "SettingsTabLayout.module__container___b3J0Qz",
  "Qs": "SettingsTabLayout.module__content___b3J0Qz",
  "mK": "SettingsTabLayout.module__subsection___b3J0Qz",
};

module.exports = exports;
